import React, { useState } from "react";
import { getContentCollaboration2 } from "../../api/collaborationApi";

import avatar from './../../utils/images/avatar_fluincr.png';
import photos from './../../utils/images/photos.svg';
import video from './../../utils/images/video.svg';

import ModalCarouselCollaborations from "../ModalCarouselCollaboration/ModalCarouselCollaboration";
import { CollaborationCardPublicProfileContainer } from "./CollaborationCardPublicProfileStyled";
import { useEffect } from "react";

export default function CollaborationCardPublicProfile({ collaboration, profileUserType }) {

    const [content, setContent] = useState([]);
    const [showCarousel, setShowCarousel] = useState(false);


    useEffect(() => {
        getContentCollaboration2({ collaborationId: collaboration.colaboration_id }).then((response) => {
            setContent(response)
        })
    }, [])



    return (
        <CollaborationCardPublicProfileContainer>

            <div className="cardCollaboration" style={{ backgroundImage: `url(${(collaboration.cover !== null) ? collaboration.cover : avatar})` }} onClick={() => {
                setShowCarousel(true)
            }}>

                {(content.length > 1) && (<img src={photos} alt="photos" className="typeIcon" />)}

                {(content.length === 1 && JSON.parse(content[0].title).name !== 'photo') && (<img src={video} alt="videos" className="typeIcon" />)}

                {(content.length === 1 && JSON.parse(content[0].title).name === 'photo') && (<div className="photoIcon" />)}

                {(profileUserType === 'company') && (<div className="colaborator" style={{ backgroundImage: `url(${(collaboration.image_influencer === null) ? avatar : collaboration.image_influencer})` }}>
                </div>)}

                {(profileUserType === 'Influencer') && (<div className="colaborator" style={{ backgroundImage: `url(${(collaboration.imageprofile === null) ? avatar : collaboration.imageprofile})` }}>
                </div>)}

            </div>

            {(showCarousel) && (<ModalCarouselCollaborations content={content.filter(element => !element.content.includes("empty"))} setShowModalCarousel={setShowCarousel} collaboration={collaboration} profileUserType={profileUserType} />)}

        </CollaborationCardPublicProfileContainer>
    )
}